import React, { useContext } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'
import { Negativation } from 'models/Invoice'
import moment from 'moment'

import { NegativateStatus } from 'utils/enums'

import { theme } from 'styles/theme'

import { ModalChargeDetailContext } from '../../context'
import { cardTittle } from '../../ModalChargeDetail.utils'
import { S } from './'
interface NegativationDetailProps {
  recurrenceNegativationData?: Negativation
}
const NegativationDetail = ({
  recurrenceNegativationData
}: NegativationDetailProps) => {
  const { invoice } = useContext(ModalChargeDetailContext)
  const data = {
    ...(!!invoice && {
      created_at: invoice?.negativation?.negativation?.created_at,
      status: invoice?.negativation?.negativation?.status,
      days_to_report: invoice?.negativation?.days_to_report,
      warnings: invoice?.negativation?.warnings
    }),
    ...(!!recurrenceNegativationData && {
      created_at: recurrenceNegativationData?.negativation?.created_at,
      status: recurrenceNegativationData?.negativation?.status,
      days_to_report: recurrenceNegativationData?.days_to_report
    })
  }
  if (!data.days_to_report && !data.created_at) {
    return null
  }
  return (
    <Accordion
      sx={{
        border: '1px solid #E8EBE8',
        borderLeft: '3px solid',
        borderLeftColor: 'primary.main',
        borderRadius: '8px !important',
        backgroundColor: '#FAFBFA',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        '&.Mui-expanded': {
          margin: 0,
          backgroundColor: '#fff'
        }
      }}
    >
      <AccordionSummary aria-controls="payerDetails-content" id="payerDetails">
        {cardTittle(
          'Detalhes da negativação',
          'thumbDownAlt',
          `${theme.palette.primary.main}`
        )}
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {data.created_at && (
            <Box
              display="flex"
              gap={1.25}
              alignItems="end"
              margin={'10px 0px 10px 0px'}
            >
              <Typography variant="smLight" color="#777777">
                Data negativação:
              </Typography>
              <S.Separator sx={{ marginTop: '4px' }} />
              <Typography variant="smBold" display="flex" alignItems="center">
                {moment(data?.created_at).format('DD/MM/yyyy')}
              </Typography>
            </Box>
          )}
          {data?.status && (
            <Box
              display="flex"
              gap={1.25}
              alignItems="end"
              margin={'10px 0px 10px 0px'}
            >
              <Typography variant="smLight" color="#777777">
                Etapa do processo:
              </Typography>
              <S.Separator sx={{ marginTop: '4px' }} />
              <Typography variant="smBold" display="flex" alignItems="center">
                {NegativateStatus[data?.status]}
              </Typography>
            </Box>
          )}
          {data?.days_to_report && (
            <Box
              display="flex"
              gap={1.25}
              alignItems="end"
              margin={'10px 0px 10px 0px'}
            >
              <Typography variant="smLight" color="#777777">
                Negativar após:
              </Typography>
              <S.Separator sx={{ marginTop: '4px' }} />
              <Typography variant="smBold" display="flex" alignItems="center">
                {data.days_to_report}{' '}
                {Number(data.days_to_report) === 1 ? 'dia' : 'dias'}
              </Typography>
            </Box>
          )}
          {data?.warnings && !data?.status && (
            <>
              <Box
                display="flex"
                gap={1.25}
                alignItems="end"
                margin={'10px 0px 10px 0px'}
              >
                <Typography variant="smLight" color="#777777">
                  Avisos antes da negativação:
                </Typography>
                <S.Separator sx={{ marginTop: '4px' }} />
                <Typography variant="smBold" display="flex" alignItems="center">
                  {data.warnings.count === 0
                    ? 'Nenhum'
                    : `${data.warnings.count} ${
                        data.warnings.count === 1
                          ? 'notificação extra'
                          : 'notificações extras'
                      } da régua`}
                </Typography>
              </Box>
              {data.warnings.next_at && (
                <Box
                  display="flex"
                  gap={1.25}
                  alignItems="end"
                  margin={'10px 0px 10px 0px'}
                >
                  <Typography variant="smLight" color="#777777">
                    Próximo aviso:
                  </Typography>
                  <S.Separator sx={{ marginTop: '4px' }} />
                  <Typography
                    variant="smBold"
                    display="flex"
                    alignItems="center"
                  >
                    {moment(data.warnings.next_at).format('DD/MM/yyyy')}
                    {data.warnings.next_channels.length > 0 &&
                      ` (${data.warnings.next_channels
                        .map(
                          (channel) =>
                            ({ email: 'E-mail', sms: 'SMS', whats: 'WhatsApp' }[
                              channel
                            ])
                        )
                        .join(', ')})`}
                  </Typography>
                </Box>
              )}
            </>
          )}
          {/* TODO: Verificar termo aditivo */}
          {/* <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin={'10px 0px 10px 0px'}
          >
            <Typography variant="smLight" color="#777777">
              Termo aditivo:
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography
              variant="smBold"
              display="flex"
              alignItems="center"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
              Visualizar termo
            </Typography>
          </Box> */}
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default NegativationDetail
